import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import S from 'app/features/newLanding/components/newProductComparison/Product/Benefit.styled';
import BenefitCheckMarkIcon from 'app/features/newLanding/components/newProductComparison/icons/BenefitCheckMarkIcon';
import BenefitCrownIcon from 'app/features/newLanding/components/newProductComparison/icons/BenefitCrownIcon';
import BenefitCrossIcon from 'app/features/newLanding/components/newProductComparison/icons/BenefitCrossIcon';
import Text from 'app/components/layout/Text.styled';

const Benefit = ({
  titleId,
  isActive,
  isVisibleOnDesktop,
  isVisibleOnMobile,
  isReferenceBenefit,
  values,
}) => {
  const ActiveIcon = isReferenceBenefit
    ? BenefitCrownIcon
    : BenefitCheckMarkIcon;

  return (
    <S.Benefit
      isActive={isActive}
      isVisibleOnMobile={isVisibleOnMobile}
      isVisibleOnDesktop={isVisibleOnDesktop}
      isReferenceBenefit={isReferenceBenefit}
      data-t={`benefit-${isActive ? 'available' : 'unavailable'}`}
    >
      {isActive ? <ActiveIcon /> : <BenefitCrossIcon />}
      <Text size="m" isFixedSize as={S.Benefit.Title}>
        <FormattedMessage
          id={titleId}
          values={{
            bold: text => <Text type="heavy">{text}</Text>,
            placeholder: values.placeholder && (
              <S.Benefit.Title.Placeholder>
                <FormattedMessage id={values.placeholder} />
              </S.Benefit.Title.Placeholder>
            ),
            prevProductTitleKey: values.prevProductTitleKey && (
              <S.Benefit.Title.PrevSubscription>
                <FormattedMessage id={values.prevProductTitleKey} />
              </S.Benefit.Title.PrevSubscription>
            ),
          }}
        />
      </Text>
    </S.Benefit>
  );
};

Benefit.propTypes = {
  titleId: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isVisibleOnMobile: PropTypes.bool,
  isVisibleOnDesktop: PropTypes.bool,
  isReferenceBenefit: PropTypes.bool,
  values: PropTypes.shape({
    placeholder: PropTypes.string,
    prevProductTitleKey: PropTypes.string,
  }),
};

Benefit.defaultProps = {
  isVisibleOnMobile: false,
  isVisibleOnDesktop: true,
  isReferenceBenefit: false,
  values: {},
};

export default Benefit;
